var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "starter-page" },
    [
      _vm.modal.task
        ? _c("user-picker-modal", {
            attrs: {
              visible: _vm.modal.assignedBy,
              title: _vm.modal.title,
              role: "ASSIGNER",
              multi: false,
            },
            on: {
              okClicked: _vm._onModalAssignedByOKClicked,
              closeClicked: function ($event) {
                _vm.modal.assignedBy = false
              },
            },
            model: {
              value: _vm.modal.task.assignedBy,
              callback: function ($$v) {
                _vm.$set(_vm.modal.task, "assignedBy", $$v)
              },
              expression: "modal.task.assignedBy",
            },
          })
        : _vm._e(),
      _vm.modal.task
        ? _c("user-picker-modal", {
            attrs: {
              visible: _vm.modal.assignedTo,
              title: _vm.modal.title,
              role: "ASSIGNEE",
              multi: false,
            },
            on: {
              okClicked: _vm._onModalAssignedToOKClicked,
              closeClicked: function ($event) {
                _vm.modal.assignedTo = false
              },
            },
            model: {
              value: _vm.modal.task.assignedTo,
              callback: function ($$v) {
                _vm.$set(_vm.modal.task, "assignedTo", $$v)
              },
              expression: "modal.task.assignedTo",
            },
          })
        : _vm._e(),
      _vm.project && _vm.showFinance
        ? _c(
            "portal",
            { attrs: { to: "sidebar" } },
            [
              _c("finance", {
                attrs: {
                  show: _vm.showFinance,
                  fullWidth: false,
                  project: _vm.project,
                },
                on: {
                  outSideClicked: function ($event) {
                    _vm.showFinance = false
                  },
                  paymentSuccess: _vm._onPaymentSuccess,
                  inviteSuccess: _vm._onInviteSuccess,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.project && _vm.showApproval
        ? _c(
            "portal",
            { attrs: { to: "sidebar" } },
            [
              _c("approval", {
                attrs: {
                  show: _vm.showApproval,
                  fullWidth: false,
                  project: _vm.project,
                },
                on: {
                  outSideClicked: function ($event) {
                    _vm.showApproval = false
                  },
                  approveSuccess: _vm._onApproveSuccess,
                  inviteSuccess: _vm._onInviteSuccess,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.project && _vm.showAcceptance
        ? _c(
            "portal",
            { attrs: { to: "sidebar" } },
            [
              _c("acceptance", {
                attrs: {
                  show: _vm.showAcceptance,
                  fullWidth: false,
                  project: _vm.project,
                  budget: _vm.taskBudget,
                  tasks: _vm.approvalTasks,
                },
                on: {
                  outSideClicked: function ($event) {
                    _vm.showAcceptance = false
                  },
                  onAccept: _vm._onAcceptClicked,
                  onReject: _vm._onCancelTermsClicked,
                  paymentSuccess: _vm._onPaymentSuccess,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.project && _vm.showCardUpdate
        ? _c(
            "portal",
            { attrs: { to: "sidebar" } },
            [
              _c("CardUpdate", {
                attrs: {
                  show: _vm.showCardUpdate,
                  fullWidth: false,
                  project: _vm.project,
                },
                on: {
                  outSideClicked: function ($event) {
                    _vm.showCardUpdate = false
                  },
                  updateSuccess: _vm._onUpdateCardSuccess,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex flex-column justify-start" },
        [
          _vm.query &&
          Object.keys(_vm.query).length > 0 &&
          _vm.searchResults &&
          _vm.profile &&
          !_vm.ganttView &&
          _vm.previewMode
            ? _c("table-view-preview", {
                attrs: { project: _vm.project, tasks: _vm.searchResults },
                on: {
                  taskCreated: _vm.refreshRecords,
                  paymentSuccess: _vm.refreshRecords,
                  approveSuccess: _vm.refreshRecords,
                },
              })
            : _vm._e(),
          _vm.query &&
          Object.keys(_vm.query).length > 0 &&
          _vm.searchResults &&
          _vm.profile &&
          !_vm.ganttView &&
          !_vm.previewMode
            ? _c("table-view", {
                attrs: { project: _vm.project, tasks: _vm.searchResults },
                on: {
                  taskCreated: _vm.refreshRecords,
                  taskDeleted: _vm.refreshRecords,
                  projectUpdated: _vm.refreshRecords,
                  selectAllClicked: _vm._onSelectAllClicked,
                },
              })
            : _vm._e(),
          _vm.query &&
          Object.keys(_vm.query).length > 0 &&
          _vm.searchResults &&
          _vm.profile &&
          _vm.ganttView
            ? _c("Gantt", {
                ref: "ab",
                attrs: {
                  enableResize: true,
                  currency: _vm.profile.currency,
                  ganttView: _vm.profile.ganttViewMode,
                  ganttDay: _vm.profile.ganttDayMode,
                  ganttComment:
                    _vm.profile &&
                    _vm.profile.role &&
                    _vm.profile.role.name != "guest"
                      ? _vm.profile.ganttCommentMode
                      : "task-title",
                  ganttZoom: _vm.profile.ganttZoomMode,
                  showBilling: _vm.profile.showFinance == "1",
                  tasks: _vm.searchResults,
                  showAssignedTo: true,
                  "color-class": "projectGantt",
                },
                on: {
                  "task-dragged": _vm.handleTaskDragged,
                  "task-link-clicked": _vm.handleTaskLinkClick,
                  "task-dbl-click": _vm.handleTaskDblClick,
                  "assigned-by-user-clicked": _vm.handleAssignedByUserClicked,
                  "assigned-to-user-clicked": _vm.handleAssignedToUserClicked,
                },
              })
            : _vm._e(),
          _vm.tasks && _vm.profile && !_vm.ganttView && _vm.previewMode
            ? _c("table-view-preview", {
                attrs: { project: _vm.project, tasks: _vm.tasks },
                on: {
                  taskCreated: _vm.refreshRecords,
                  approveSuccess: _vm.refreshRecords,
                  paymentSuccess: _vm.refreshRecords,
                },
              })
            : _vm._e(),
          _vm.tasks && _vm.profile && !_vm.ganttView && !_vm.previewMode
            ? _c("table-view", {
                attrs: { project: _vm.project, tasks: _vm.tasks },
                on: {
                  taskCreated: _vm.refreshRecords,
                  taskDeleted: _vm.refreshRecords,
                  projectUpdated: _vm.refreshRecords,
                  selectAllClicked: _vm._onSelectAllClicked,
                  approveClicked: _vm._onAcceptanceClicked,
                  overDueClicked: _vm._onOverDueClicked,
                },
              })
            : _vm._e(),
          _vm.tasks && _vm.profile && _vm.ganttView
            ? _c("Gantt", {
                ref: "aa",
                attrs: {
                  currency: _vm.profile.currency,
                  enableResize: true,
                  ganttView: _vm.profile.ganttViewMode,
                  ganttDay: _vm.profile.ganttDayMode,
                  ganttComment:
                    this.profile &&
                    this.profile.role &&
                    this.profile.role.name != "guest"
                      ? _vm.profile.ganttCommentMode
                      : "task-title",
                  ganttZoom: _vm.profile.ganttZoomMode,
                  showBilling: _vm.profile.showFinance == "1",
                  tasks: _vm.tasks,
                  showAssignedTo: true,
                  "color-class": "projectGantt",
                },
                on: {
                  "task-dragged": _vm.handleTaskDragged,
                  dblClickEmptyArea: _vm.handleTaskDblClick,
                  "task-link-clicked": _vm.handleTaskLinkClick,
                  "task-dbl-click": _vm.handleTaskDblClick,
                  "assigned-by-user-clicked": _vm.handleAssignedByUserClicked,
                  "assigned-to-user-clicked": _vm.handleAssignedToUserClicked,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.tasks && _vm.ganttView
        ? _c(
            "div",
            {
              staticClass:
                "project__details text-primary text-lg font-weight-light",
            },
            [
              _vm._v("\n    Total\n    "),
              _vm.query &&
              (!_vm.query.q ||
                _vm.query.q == "" ||
                Object.keys(_vm.query).length > 0) &&
              _vm.searchResults &&
              _vm.profile
                ? _c("b", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.searchResults.data.length)),
                  ])
                : _vm._e(),
              _vm.query &&
              (!_vm.query.q ||
                _vm.query.q == "" ||
                Object.keys(_vm.query).length > 0) &&
              _vm.tasks &&
              _vm.profile
                ? _c("b", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.tasks.data.length)),
                  ])
                : _vm._e(),
              _vm._v("\n    Bracket(s)\n  "),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }